<template>
  <div id="app">
    <router-view v-if="routerState" />
  </div>
</template>

<script>
export default {
  name: 'App',
  // 向子组件注入依赖
  provide() {
    return {
      reload: this.reload,
    }
  },
  // 声明变量
  data() {
    return {
      routerState: true,
      cachedViews: "首页,收费标准"
    }
  },
  created() { },
  computed: {
    key() {
      console.log(this.$route.path, 'this.$route.path');
      return this.$route.path
    }
  },
  methods: {
    // 利用$nextTick特性，router跳转完成后展示页面
    reload() {
      // console.log(this.routerState,'this.routerState');
      this.routerState = false
      this.$nextTick(() => {
        this.routerState = true
      })
    },
  },
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue